import { StateCreator } from "zustand";

import { RootStore } from "./";

export interface LegendActions {
	openLegendTool: () => void;
}

export type LegendStore = LegendActions;

export const createLegendSlice: StateCreator<RootStore, [], [], LegendStore> = (
	set,
) => ({
	openLegendTool: () => set({ currentMapToolView: "legend" }),
});
